import { Link } from "react-router-dom";

/**
 * ClientOps wordmark. Pass `tagline` (default: none) to show a small
 * "NZ Taxation Limited t/a ClientOps" line underneath — used on the funnel,
 * login, and client portal so lead + client-facing surfaces make it clear
 * that ClientOps is the trading name of the legal entity.
 */
export default function Brand({ size = "md", to = "/", className = "", tagline = false }) {
    const sz = size === "sm" ? "text-base" : size === "lg" ? "text-2xl" : "text-lg";
    return (
        <Link to={to} className={`inline-flex flex-col ${className}`} data-testid="brand-link">
            <span className="flex items-center gap-2">
                <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-[#171717] text-white font-display font-semibold text-sm">C</span>
                <span className={`font-display font-semibold tracking-tight ${sz}`}>ClientOps</span>
            </span>
            {tagline && (
                <span className="mt-0.5 pl-9 text-[10px] font-medium uppercase tracking-wider text-[#5E636E]" data-testid="brand-tagline">
                    NZ Taxation Limited t/a ClientOps
                </span>
            )}
        </Link>
    );
}
